"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogConsumer = exports.DialogContext = void 0;

const react_1 = __importStar(require("react"));

const AnimatedDialogContainer_1 = __importDefault(require("../components/animated-dialog-container/AnimatedDialogContainer"));

exports.DialogContext = react_1.createContext({
  openDialog: () => {
    console.warn('openDialog was called without a <DialogProvider>.');
    return undefined;
  },
  closeDialog: () => {
    console.warn('closeDialog was called without a <DialogProvider>.');
  }
});
/**
 * @deprecated The DialogProvider has been deprecated and will be removed in a
 * future breaking change. Instead, you can simply render an Overlay component
 * and place a Dialog (or any other component) inside.
 */

const DialogProvider = _a => {
  var {
    container: Container = AnimatedDialogContainer_1.default
  } = _a,
      props = __rest(_a, ["container"]);

  const [dialog, setDialog] = react_1.useState(undefined);
  const [visible, setVisible] = react_1.useState(false);

  const openDialog = dialog => {
    setDialog(dialog);
    setVisible(true);
  };

  const closeDialog = () => {
    setVisible(false);
  };

  react_1.useEffect(() => {
    const closeOnEscape = event => {
      if (event.key === 'Escape') closeDialog();
    };

    window.document.addEventListener('keyup', closeOnEscape);
    return () => {
      window.document.removeEventListener('keyup', closeOnEscape);
    };
  });
  return react_1.default.createElement(exports.DialogContext.Provider, {
    value: {
      openDialog,
      closeDialog
    }
  }, react_1.default.createElement(Container, {
    visible: visible
  }, dialog), props.children);
};

exports.default = DialogProvider;
exports.DialogConsumer = exports.DialogContext.Consumer;